import { render, staticRenderFns } from "./reward-config.vue?vue&type=template&id=99d2f800&scoped=true"
import script from "./reward-config.vue?vue&type=script&lang=js"
export * from "./reward-config.vue?vue&type=script&lang=js"
import style0 from "./reward-config.vue?vue&type=style&index=0&id=99d2f800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e639414b8f28593ae71b2a471b1115a5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d2f800",
  null
  
)

export default component.exports